import styled from 'styled-components'

export const StyledNewsLanguageAlert = styled.div``
